export enum StatusEnum {
    PENDING = "P",
    ACTIVADO = "A" ,
    CREATED = "C",
    INACTIVE = "I",
    SUSPENDIDO = "S",
    CURSO = "EN CURSO",
    PROGRAMADO = "PROGRAMADO",
}
